import { Platform } from 'react-native';
import * as ipHelper from 'react-native-iphone-screen-helper';
import { initialWindowMetrics } from 'react-native-safe-area-context';

export function isIphoneX() {
  return ipHelper.isIphoneX();
}

export function ifIphoneX(iphoneXStyle, regularStyle) {
  if (isIphoneX()) {
    return iphoneXStyle;
  }
  return regularStyle;
}

export function getStatusBarHeight(safe) {
  return Platform.OS === 'android' && initialWindowMetrics?.insets ? initialWindowMetrics?.insets?.top || 20 : ipHelper.getStatusBarHeight();
}

export function getBottomSpace() {
  return Platform.OS === 'android' && initialWindowMetrics?.insets ? initialWindowMetrics?.insets?.bottom || 0 : ipHelper.getBottomSpace();
}

export default {
  isIphoneX,
  ifIphoneX,
  getStatusBarHeight,
  getBottomSpace
};
